import type { FC, ReactNode } from "react";
import { formatYen, type OrderDetailDTO } from "../../components/format";
import { SectionHeading } from "../../components/SectionHeading";

/**
 * お支払いの内訳。支払い前・差額の未払いのお願い (やり直しのボタン・支払い方法ごとの案内) は
 * 注文詳細の最上部「ご対応のお願い」に出す。
 */
export const PaymentSection: FC<{ order: OrderDetailDTO }> = ({ order }) => (
  <section className="mb-10">
    <SectionHeading title="お支払い" />
    <dl className="divide-y divide-neutral-200 text-sm">
      {order.paymentMethods.length > 0 && (
        <PaymentRow label="お支払い方法" value={order.paymentMethods.join(" / ")} />
      )}
      <PaymentRow label="商品小計" value={formatYen(order.subtotalJpy)} />
      {order.discountJpy > 0 && (
        <PaymentRow label="ディスカウント" value={`- ${formatYen(order.discountJpy)}`} />
      )}
      <PaymentRow
        label="送料"
        value={order.shippingJpy === 0 ? "無料" : formatYen(order.shippingJpy)}
      />
      {order.taxJpy > 0 && <PaymentRow label="消費税" value={formatYen(order.taxJpy)} />}
      <PaymentRow label="合計" value={formatYen(order.totalPriceJpy)} bold />
    </dl>
  </section>
);

const PaymentRow: FC<{ label: string; value: ReactNode; bold?: boolean }> = ({
  label,
  value,
  bold,
}) => (
  <div className="flex items-baseline justify-between gap-3 py-3">
    <dt className="text-neutral-500">{label}</dt>
    <dd className={`text-neutral-900 ${bold ? "font-medium" : ""}`}>{value}</dd>
  </div>
);
